import Vue from 'vue';

const success = (data, resolve) => {
  resolve(data.data);
};

const failed = () => {};

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/adjustments/adjustment-types/all')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/adjustment/adjustmentType.js